import { render, staticRenderFns } from "./AddressSearchPage.vue?vue&type=template&id=b4ee1880&scoped=true&lang=pug&"
import script from "./AddressSearchPage.vue?vue&type=script&lang=ts&"
export * from "./AddressSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddressSearchPage.vue?vue&type=style&index=0&id=b4ee1880&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ee1880",
  null
  
)

export default component.exports